import {Html, Icon} from 'quickstart/components/content'
import {Button, Search} from 'quickstart/components/controls'
import {Box, Modal, useModalState} from 'quickstart/components/layout'
import {useAutoComplete, useMarkdown, UseSearchReturn} from 'quickstart/hooks'
import * as R from 'rambdax'
import {ComponentProps, forwardRef} from 'react'
import {logger} from 'tizra'

const log = logger('quickstart/components/tizra/SearchTermsInput')

type SearchTermsInputProps = ComponentProps<typeof Search> & {
  search: UseSearchReturn
  tips?: string
}

export const SearchTermsInput = forwardRef<unknown, SearchTermsInputProps>(
  ({search: {config}, tips, ...rest}, ref) => {
    const autocomplete = useAutoComplete(config)

    const modal = useModalState()
    const tipsHtml = useMarkdown(tips, {allowDangerousHtml: true}) || ''
    const hint = !tips ? undefined : (
      <Box>
        <Modal.Trigger
          as={Button}
          // Bury the Button props to avoid TS errors for Modal.Trigger
          {...{variant: 'stealth', color: 'linkColor'}}
          {...modal}
        >
          <Icon icon="info" />
          See tips
        </Modal.Trigger>{' '}
        for using special search characters
      </Box>
    )

    return (
      <>
        <Search
          // @ts-expect-error
          itemToString={R.prop('full')}
          ref={ref}
          // @ts-expect-error
          renderItem={item => (
            <span>
              {item.before}
              <strong style={{fontWeight: 'bold'}}>{item.suggestion}</strong>
              {item.after}
            </span>
          )}
          search={autocomplete}
          hint={hint}
          {...rest}
        />
        <Modal {...modal}>
          <Modal.Title>Search Tips</Modal.Title>
          <Modal.Content>
            <Html html={tipsHtml} variant="raw" />
          </Modal.Content>
        </Modal>
      </>
    )
  },
)
